@if (spinnerService.loading()) {
  <div class="ks-spinner-overlay" role="alertdialog" aria-live="assertive" aria-busy="true">
    <div class="ks-spinner-card">
      <span class="ks-spinner" aria-hidden="true"></span>
      <p class="ks-spinner__message">{{ spinnerService.message() }}</p>
    </div>
  </div>
}
